export default __webpack_public_path__ + "images/iconPlanMorningNight.05cb14a560ed5cdbadcf01e8f54cfeaf.svg"